import React from 'react';

import styles from './styles.module.scss';

import { ListOnRoveLandingType } from '@utils/types/landings';
import ContactForm from '@components/landing/_shared/contactForm';

const ListOnRoveContact = (props: ListOnRoveLandingType['contact']) => {
  const { title, description, cta } = props;

  return (
    <div className={styles.contact} id="contact">
      <div className={styles.contact__wrapper}>
        <div className={styles.contact__content}>
          <h2 className={styles.contact__title}>{title}</h2>
          <p className={styles.contact__description}>{description}</p>
        </div>

        <ContactForm cta={cta} containerStyle={styles.contact__form} />
      </div>
    </div>
  );
};

export default ListOnRoveContact;
